import React, {useState} from 'react';
import {ActionIcon, Button, Center, Group, Tooltip} from '@mantine/core';
import classes from './Header.module.css';
import {
    IconChartBar,
    IconEdit,
    IconGauge,
    IconLayoutGrid,
    IconShield,
    IconShieldOff,
    IconUsersGroup,
} from '@tabler/icons-react';
import {Link, useLocation} from 'react-router-dom';
import {RouteUtils} from '@bobex/react-core/routes/RouteUtils';
import {authorityGuardDevStore} from '@bobex/react-core/routes/authorityGuardDevStore';

export const headerLinks = [
    {link: '/dashboard', label: 'Dashboard', icon: IconGauge, color: 'green'},
    {link: '/sitemap', label: 'Sitemap', icon: IconLayoutGrid, color: 'indigo'},
    {link: '/charts-home', label: 'Charts', icon: IconChartBar, color: 'blue'},
    {
        link: '/partner-rfp-search-form',
        label: 'Search lead',
        icon: IconEdit,
        color: 'yellow',
    },
    {link: '/search-user', label: 'Search user', icon: IconUsersGroup, color: 'red'},
];

export function isHeaderLinkActive(currentPath: string, link: string): boolean {
    if (link === '/charts-home') {
        return currentPath === '/charts-home' || currentPath.endsWith('/charts-home');
    }
    if (link.startsWith('http') || link.startsWith(RouteUtils.getBackofficeServletBasename() ?? '')) {
        return false; // external/servlet links never active in React
    }
    return currentPath === link || currentPath.startsWith(link + '/');
}

export default function Header() {
    const location = useLocation();
    const currentPath = location.pathname;
    const [devEnabled, setDevEnabled] = useState(() =>
            import.meta.env.DEV ? authorityGuardDevStore.isEnabled() : false
    );

    const items = headerLinks.map((link, index) => {
        const active = isHeaderLinkActive(currentPath, link.link);
        const haloStyle = active
                ? {boxShadow: `0 0 0 2px var(--mantine-color-${link.color}-4)`}
                : undefined;
        return (
                <React.Fragment key={index}>
                    <ActionIcon
                            color={link.color}
                            size="lg"
                            key={link.label}
                            component={Link}
                            to={link.link}
                            className={classes.link}
                            data-active={active || undefined}
                            variant={active ? 'outline' : 'filled'}
                            style={haloStyle}
                    >
                        <Center>{link.icon && <link.icon size={20}/>}</Center>
                    </ActionIcon>
                </React.Fragment>
        );
    });

    return (
            <Group justify="space-between" wrap={'nowrap'}>
                {items}
                {import.meta.env.DEV && (
                        <Tooltip label={devEnabled ? 'Disable AuthorityGuard overlay' : 'Enable AuthorityGuard overlay'}
                                 withArrow>
                            <Button
                                    size="sm"
                                    variant={devEnabled ? 'filled' : 'outline'}
                                    color={devEnabled ? 'violet' : 'gray'}
                                    onClick={() => setDevEnabled(authorityGuardDevStore.toggle())}
                            >
                                <Center>{devEnabled ? <IconShield size={20}/> : <IconShieldOff size={20}/>}</Center>
                                {"Dev mode"}
                            </Button>
                        </Tooltip>
                )}
            </Group>
    );
}
